export const enum FilterType {
  EQUAL = 'equal',
  NOT_EQUAL = 'not_equal',
  LESS_THAN = 'less_than',
  LESS_THAN_OR_EQUAL = 'less_than_or_equal',
  GREATER_THAN = 'greater_than',
  GREATER_THAN_OR_EQUAL = 'greater_than_or_equal',
  IN = 'in',
  NOT_IN = 'not_in',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with'
}

type Filter = {
  key: string
  value: any
  type: FilterType
}

export type FilterCondition = {
  condition?: 'AND' | 'OR'
  filters: Filter[]
}

function filtering<T>(filter: Filter, item: T) {
  switch (filter.type) {
    case FilterType.EQUAL:
      return item[filter.key] === filter.value
    case FilterType.NOT_EQUAL:
      return item[filter.key] !== filter.value
    case FilterType.LESS_THAN:
      return item[filter.key] < filter.value
    case FilterType.LESS_THAN_OR_EQUAL:
      return item[filter.key] <= filter.value
    case FilterType.GREATER_THAN:
      return item[filter.key] > filter.value
    case FilterType.GREATER_THAN_OR_EQUAL:
      return item[filter.key] >= filter.value
    case FilterType.IN:
      return item[filter.key] && item[filter.key].includes(filter.value)
    case FilterType.NOT_IN:
      return item[filter.key] && !item[filter.key].includes(filter.value)
    case FilterType.CONTAINS:
      return item[filter.key] && item[filter.key].toString().includes(filter.value)
    case FilterType.NOT_CONTAINS:
      return item[filter.key] && !item[filter.key].toString().includes(filter.value)
    case FilterType.STARTS_WITH:
      return item[filter.key] && item[filter.key].toString().startsWith(filter.value)
    case FilterType.ENDS_WITH:
      return item[filter.key] && item[filter.key].toString().endsWith(filter.value)
    default:
      return false
  }
}
/*
 * data: Array<T>
 * filters: Array<Filter>
 * useFilter(data, [{condition:'OR',filters:[{key:'codigo',value:'N',type:FT.EQUAL},{key:'codigo',value:'X',type:FT.EQUAL}]},{condition:'AND',filters:[{key:'codigoTipoPersona',value:tipoPersona?.codigo,type:FT.EQUAL}]}])
 */

export function queryFilter<T>(data: T[], filters: FilterCondition[]): T[] {
  return data.filter((item: T) => {
    return filters.every(({ condition, filters }) => {
      if (condition === 'AND') {
        return filters.every(filter => {
          return filtering(filter, item)
        })
      }
      return filters.some(filter => {
        return filtering(filter, item)
      })
    })
  })
}
